import type { PayloadPostMerchflows_merchflowId_ExportsBatch } from "@CommonApi/merchflows/_merchflowId_/exports/batch";
import { omniAtom } from "src/utils/atoms";

export interface PogCsvColumnsModalData {
  merchflowId: number;
  payload: Exclude<PayloadPostMerchflows_merchflowId_ExportsBatch, { base_pog_ids: number[] }> & {
    type: "csv";
  };
  onSuccess?: () => void;
}

export const pogCsvColumnsModalDataAtom = omniAtom({
  key: "modals/pogCsvColumns",
  value: null as PogCsvColumnsModalData | null,
});
